module.exports = __webpack_public_path__ + "static/media/fortmatic.f886c8c5.svg";